import React from "react";
import { useSearchParams } from "react-router-dom";
import AdminAiIntegration from "../AI/AdminAiIntegration";
import AdminPaytrIntegration from "./AdminPaytrIntegration";

// Yeni entegrasyon eklemek için bu listeye bir satır eklemek yeterli.
const TABS = [
    { key: "gemini", label: "Gemini", icon: "fas fa-robot", Component: AdminAiIntegration },
    { key: "paytr", label: "PayTR", icon: "fas fa-credit-card", Component: AdminPaytrIntegration },
];

export const AdminIntegrations = () => {
    // Seçili sekme adreste durur (/admin/integrations?tab=paytr); sayfa yenilenince kaybolmaz.
    const [searchParams, setSearchParams] = useSearchParams();
    const active = TABS.find((t) => t.key === searchParams.get("tab")) || TABS[0];
    const ActiveComponent = active.Component;

    return (
        <div className="container-fluid pt-4 bg-light min-vh-100">
            <h3 className="fw-bold text-primary mb-3">Entegrasyonlar</h3>
            <ul className="nav nav-tabs">
                {TABS.map((t) => (
                    <li className="nav-item" key={t.key}>
                        <button
                            type="button"
                            className={`nav-link ${t.key === active.key ? "active fw-semibold" : ""}`}
                            onClick={() => setSearchParams({ tab: t.key })}
                        >
                            <i className={`${t.icon} me-2`} aria-hidden="true"></i>{t.label}
                        </button>
                    </li>
                ))}
            </ul>
            <ActiveComponent />
        </div>
    );
};

export default AdminIntegrations;
